import { gql } from '@apollo/client';

const API_TOKEN_FIELDS = gql`
  fragment ApiTokenFields on ApiToken {
    id
    name
    tokenPrefix
    scopes
    templateIds
    allowedIps
    createdAt
    lastUsedAt
    expiresAt
    revokedAt
  }
`;

export const GET_API_TOKENS = gql`
  ${API_TOKEN_FIELDS}
  query GetApiTokens {
    apiTokens {
      ...ApiTokenFields
    }
  }
`;

export const CREATE_API_TOKEN = gql`
  ${API_TOKEN_FIELDS}
  mutation CreateApiToken(
    $name: String!
    $scopes: [String!]
    $templateIds: [String!]
    $allowedIps: [String!]
    $expiresAt: String
  ) {
    createApiToken(
      name: $name
      scopes: $scopes
      templateIds: $templateIds
      allowedIps: $allowedIps
      expiresAt: $expiresAt
    ) {
      token
      apiToken {
        ...ApiTokenFields
      }
    }
  }
`;

export const REVOKE_API_TOKEN = gql`
  ${API_TOKEN_FIELDS}
  mutation RevokeApiToken($id: ID!) {
    revokeApiToken(id: $id) {
      ...ApiTokenFields
    }
  }
`;
